import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { nextStep, prevStep } from "./stepSlice";
import Onboadingstep1 from "./Onboadingstep1";
import Onboadingstep2 from "./Onboadingstep2";
import Onboadingstep3 from "./Onboadingstep3";
import Onboadingstep4 from "./Onboadingstep4";
import Onboadingstep5 from "./Onboadingstep5";
import Onboadingstep6 from "./Onboadingstep6";
import Onboadingstep7 from "./Onboadingstep7";
import step0 from "../assets/step0.png";
import step1 from "../assets/step1.png";
import step2 from "../assets/step2.png";
import step3 from "../assets/step3.png";
import step4 from "../assets/step4.png";
import step5 from "../assets/step5.png";
import { handleError } from "../CommonJquery/CommonJquery";
import {
  save_onboarding,
  get_new_resturant,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { storeData, retrieveData } from "../LocalConnection/LocalConnection.js";
import "./Css/Newonboading.css";
import "./Css/Onboading.css";

const ONBOARD_ID_KEY = "default_restaurant_id_staff";

const AddRestaurantNew = () => {
  const { id, id2 } = useParams();

  const [currentStep, setcurrentStep] = useState(
    useSelector((state) => state.currentStep),
  );

  const dispatch = useDispatch();
  const totalSteps = 5;
  const [restaurantName, setRestaurantName] = useState("");
  const [restaurantNameError, setRestaurantNameError] = useState(false);
  const [restaurantData, setrestaurantData] = useState([]);
  const [shake, setShake] = useState(false);
  const [isRestaurantNameFocused, setIsRestaurantNameFocused] = useState(false);
  const [isAdditionalInfoFocused, setIsAdditionalInfoFocused] = useState(false);
  const [isRestaurantDescriptionFocused, setIsRestaurantDescriptionFocused] =
    useState(false);

  const [restoDistribution, setRestoDistribution] = useState("");
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [showLoader, setshowLoader] = useState(false);
  const [progressPercentage, setProgressPercentage] = useState(0);

  // ---- id resolve: URL param > localStorage > 0 ----
  const initialId = id || retrieveData(ONBOARD_ID_KEY) || 0;
  const [resnewid, setResnewid] = useState(initialId);
  const resnewidRef = useRef(initialId); // save hamesha latest id use kare

  const setRestaurantId = (newId) => {
    if (!newId) return;
    resnewidRef.current = newId;
    setResnewid(newId);
    storeData(ONBOARD_ID_KEY, newId);
  };

  useEffect(() => {
    const progress = (currentStep / totalSteps) * 100;
    setProgressPercentage(progress);

    const interval = setInterval(() => {
      setProgressPercentage((prev) => {
        if (prev >= progress) {
          clearInterval(interval);
          return progress;
        }
        return prev + 1;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [currentStep, totalSteps]);

  // mount par ek hi baar data load ho, aur tabhi step sync ho
  useEffect(() => {
    if (id) {
      setRestaurantId(id);
      master_data_get(id, true);
    } else if (initialId && initialId !== 0) {
      resnewidRef.current = initialId;
      master_data_get(initialId, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleNextStep = () => {
    if (restaurantName.trim() === "") {
      setRestaurantNameError(true);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } else {
      handleSaveChangesdynamic();
    }
  };

  const handleInputChange = (e) => {
    setRestaurantName(e.target.value);
    if (e.target.value.trim() !== "") {
      setRestaurantNameError(false);
      setShake(false);
    }
  };

  const handleAdditionalInfoChange = (e) => {
    setAdditionalInfo(e.target.value);
  };

  const handleRestoDiscribtionChange = (e) => {
    const formattedText = e.target.value
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");

    setRestoDistribution(formattedText);
  };

  const handleSaveChangesdynamic = async () => {
    setshowLoader(true);
    const currentId = resnewidRef.current || resnewid || id || 0;
    const form_data = new FormData();
    form_data.append("restaurant_name", restaurantName);
    form_data.append("restaurant_tagline", additionalInfo);
    form_data.append("restaurant_about", restoDistribution);
    form_data.append("default_restaurant_id_new", currentId);
    form_data.append("step_save", "0");

    await server_post_data(save_onboarding, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const newId = Response.data.default_restaurant_id || currentId;
          setRestaurantId(newId);
          setRestaurantNameError(false);
          dispatch(nextStep());
          setcurrentStep((prev) => prev + 1);
        }
        setshowLoader(false);
      })
      .catch((error) => {
        setshowLoader(false);
        console.log(error);
      });
  };

  const master_data_get = async (restaurant_id, syncStep = false) => {
    setshowLoaderAdmin(true);
    const form_data = new FormData();
    const restaurantId = restaurant_id || resnewidRef.current || resnewid || id;
    form_data.append("default_restaurant_id_new", restaurantId);

    await server_post_data(get_new_resturant, form_data)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.restaurant_data.length > 0) {
            const restaurantInfo = Response.data.message.restaurant_data[0];

            setrestaurantData(restaurantInfo);
            setRestaurantName(restaurantInfo.restaurant_name || "");
            setAdditionalInfo(restaurantInfo.restaurant_tagline || "");
            setRestoDistribution(restaurantInfo.restaurant_about || "");
            setRestaurantId(restaurantInfo.primary_id || restaurantId);
            if (syncStep) {
              setcurrentStep(restaurantInfo.restaurant_step_save);
            }
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  const handlePrevStep = () => {
    dispatch(prevStep());
    setcurrentStep((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const goNext = () => {
    dispatch(nextStep());
    setcurrentStep((prev) => prev + 1);
  };

  return (
    <div style={{ overflow: "hidden", height: "100vh" }}>
      {currentStep === 13 ? (
        <>
          <Header />
        </>
      ) : (
        <div>
          <Header />

          {currentStep !== 14 && (
            <div
              className={` my-4 ${
                currentStep === 9 ? "col-md-11 mx-auto" : "container-lg"
              } h-100`}
            >
              <div className="row">
                {currentStep < 6 && (
                  <div
                    className={` hideAfter991 ${
                      currentStep === 6
                        ? "col-md-4 mx-auto"
                        : "col-lg-4 col-md-5 mx-auto"
                    } d-flex align-items-start mt-3`}
                  >
                    <div className="leftSideCont">
                      {currentStep === 0 && <img src={step0} alt="step0" />}
                      {currentStep === 1 && <img src={step1} alt="step1" />}
                      {currentStep === 2 && <img src={step2} alt="step2" />}
                      {currentStep === 3 && <img src={step3} alt="step3" />}
                      {currentStep === 4 && <img src={step4} alt="step4" />}
                      {currentStep === 5 && <img src={step5} alt="step5" />}
                    </div>
                  </div>
                )}

                <div
                  className={` ${
                    currentStep === 9
                      ? "col-11 col-xl-10 mx-auto pt-4"
                      : "col-xl-6 col-lg-7 col-md-9 col-11 mx-auto"
                  } padding000`}
                >
                  {currentStep !== 6 && currentStep !== 7 && (
                    <div className="progress-container">
                      <div className="progress-text">
                        <span>
                          {`${Math.round(progressPercentage)}%`} Completed
                        </span>
                      </div>
                      <div className="progress-bar">
                        <div
                          className="progress-fill"
                          style={{ width: `${progressPercentage}%` }}
                        ></div>
                      </div>
                    </div>
                  )}
                  {/**--------------Platform for Order and more.-------------- */}
                  {currentStep === 0 && (
                    <div className="overflowHeight">
                      <div className="containerRight maxwidthClass">
                        <div className="rightHeading">
                          <h3>
                            Your Restaurant Name Discovered on Uprestro<br></br>{" "}
                            Platform for Order and more.
                          </h3>
                          <p>
                            Enter Your Restaurant/Hotel/Cafe Name to get Started
                          </p>
                        </div>
                        <div
                          className="col-sm-10"
                          style={{ position: "relative" }}
                        >
                          <div className="restName">
                            {(isRestaurantNameFocused || restaurantName) && (
                              <label className="HeadBussiness">
                                Restaurant Name*
                              </label>
                            )}
                            <input
                              type="text"
                              minLength={3}
                              maxLength={75}
                              placeholder="Restaurant Name*"
                              className={`form-control ${
                                isRestaurantNameFocused ? "active-input" : ""
                              } ${restaurantNameError ? "input-error" : ""} ${
                                shake ? "shake" : ""
                              }`}
                              value={restaurantName
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase(),
                                )
                                .join(" ")}
                              onChange={handleInputChange}
                              onFocus={() => setIsRestaurantNameFocused(true)}
                              onBlur={() => setIsRestaurantNameFocused(false)}
                            />

                            {restaurantNameError && (
                              <span className="conditonMsgSHow">
                                Please enter the restaurant name
                              </span>
                            )}
                          </div>
                        </div>
                        <div
                          className="col-sm-10"
                          style={{ position: "relative" }}
                        >
                          <div>
                            {(isAdditionalInfoFocused || additionalInfo) && (
                              <label className="HeadBussiness">
                                Restaurant Tagline
                              </label>
                            )}
                            <input
                              type="text"
                              placeholder="Restaurant Tagline"
                              className={`form-control ${
                                isAdditionalInfoFocused ? "active-input" : ""
                              }`}
                              value={additionalInfo
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() +
                                    word.slice(1).toLowerCase(),
                                )
                                .join(" ")}
                              onChange={handleAdditionalInfoChange}
                              onFocus={() => setIsAdditionalInfoFocused(true)}
                              onBlur={() => setIsAdditionalInfoFocused(false)}
                            />
                          </div>
                        </div>
                        <div
                          className="col-sm-10 mt-2"
                          style={{ position: "relative" }}
                        >
                          <div>
                            {(isRestaurantDescriptionFocused ||
                              restoDistribution) && (
                              <label className="HeadBussiness">
                                Restaurant Description
                              </label>
                            )}
                            <textarea
                              placeholder="Let Customers learn more about your restaurant by adding ad description to your Restaurant Profile on Search."
                              className={`form-control resTdiscription restDiscrib_pdding ${
                                isRestaurantDescriptionFocused
                                  ? "active-input"
                                  : ""
                              }`}
                              value={restoDistribution}
                              onChange={handleRestoDiscribtionChange}
                              onFocus={() =>
                                setIsRestaurantDescriptionFocused(true)
                              }
                              onBlur={() =>
                                setIsRestaurantDescriptionFocused(false)
                              }
                            />
                          </div>
                        </div>
                        <div
                          className={`newClass2 fixNextButton ${
                            restaurantName.trim() !== ""
                              ? "nonEmptyBttn"
                              : "emptyFiled"
                          }`}
                          onClick={handleNextStep}
                        >
                          <div className="container-lg d-flex justify-content-end">
                            <button
                              style={{
                                marginTop: "0.5rem",
                                opacity: restaurantName.trim() === "" ? 0.5 : 1,
                                cursor: restaurantName.trim()
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/**----------Enter your restaurant address-------- */}
                  {currentStep === 1 && (
                    <Onboadingstep1
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}
                  {/**-----------Choose Your Restaurant Type--------- */}
                  {currentStep === 2 && (
                    <Onboadingstep2
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}
                  {/**-----------Choose Your Restaurant Food Type --------- */}
                  {currentStep === 3 && (
                    <Onboadingstep3
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}
                  {/**------------Restaurant Owner Details---------- */}
                  {currentStep === 4 && (
                    <Onboadingstep4
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}{" "}
                  {/**------------Restaurant Owner Details---------- */}
                  {currentStep === 5 && (
                    <Onboadingstep5
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}
                  {currentStep === 6 && (
                    <Onboadingstep6
                      resnewid={resnewid}
                      nextStep={goNext}
                      prevStep={handlePrevStep}
                    />
                  )}
                </div>
              </div>
            </div>
          )}
          {currentStep === 7 && (
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-6 col-sm-8 ">
                  <div className="EditForm">
                    <Onboadingstep7 resnewid={resnewid} />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AddRestaurantNew;
